// Formato de fecha ÚNICO del módulo Incorporaciones: dd/mm/aaaa con zona horaria
// Europe/Madrid EXPLÍCITA (convención del proyecto). Se usa Intl.DateTimeFormat con timeZone
// fijo para que una fecha (p. ej. la fecha prevista de incorporación) no se desplace un día por
// la zona del navegador. Nunca formatear con `new Date()` a pelo dependiendo de la TZ local.

const FMT_DDMMAAAA = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Madrid',
});

/** dd/mm/aaaa (Europe/Madrid). Devuelve `fallback` si el valor es vacío o no es fecha válida. */
export function fmtFecha(valor, fallback = '—') {
  if (!valor) return fallback;
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? fallback : FMT_DDMMAAAA.format(d);
}

// Fecha Y HORA, para un HECHO con momento (quién revocó y cuándo). La hora en Madrid: el servidor
// la guarda en UTC, y «11:06» leído en España sería la hora equivocada del error que se busca.
const FMT_MOMENTO = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  timeZone: 'Europe/Madrid',
});

export function fmtMomento(valor, fallback = '—') {
  if (!valor) return fallback;
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? fallback : FMT_MOMENTO.format(d).replace(', ', ' a las ');
}
